import React, { Component, ErrorInfo, ReactNode } from "react";
import * as Sentry from "@sentry/react";
import SupersetLogoHeader from "../SupersetLogoHeader/SupersetLogoHeader";
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";
import { ArrowLongLeftIcon } from "@heroicons/react/24/solid";
import { ArrowPathIcon } from "@heroicons/react/20/solid";

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

class GlobalReactErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(_: Error): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error("Uncaught error:", error, errorInfo);
    Sentry.captureException(error);
  }

  render() {
    if (this.state.hasError) {
      return (
        <>
          <SupersetLogoHeader />
          <div className="flex flex-col items-center justify-center h-[calc(100vh-63px)] bg-gray-100 text-center px-2 pb-[80px]">
            <div className="mx-auto flex h-[70px] w-[70px] flex-shrink-0 items-center justify-center rounded-full bg-indigo-100">
              <ExclamationTriangleIcon
                className="h-auto w-10 text-indigo-600"
                aria-hidden="true"
              />
            </div>
            <h1 className="text-2xl font-semibold text-indigo-600 mt-4">
              Something went wrong
            </h1>
            <p className="text-gray-700 mt-2">
              {"We're sorry, an unexpected client error occured."}
            </p>

            <div className="mt-6">
              <button
                onClick={() => window.location.reload()}
                className="inline-flex items-center rounded-md bg-indigo-600 py-2 px-4 text-sm font-medium text-white shadow-xs"
              >
                <ArrowPathIcon
                  className="h-5 w-auto text-white mr-1"
                  aria-hidden="true"
                />
                Refresh Page
              </button>

              {/* 
          TODO:
          Implement way for customer to contact support
          either email form or chat widget
          and auto include error trace/sentry id 
          */}
              {/* <a
            href="mailto:support@yourapp.com"
            className="text-blue-600 underline"
          >
            Contact Support
          </a> */}
            </div>

            <a
              href="/"
              className="text-sm text-indigo-600 font-medium flex mt-4"
            >
              <span className="flex items-center pr-1">
                <ArrowLongLeftIcon
                  className="h-5 w-auto text-indigo-600"
                  aria-hidden="true"
                />
              </span>
              Back To Home
            </a>
          </div>
        </>
      );
    }

    return this.props.children;
  }
}

export default GlobalReactErrorBoundary;
